module.exports = __webpack_public_path__ + "static/sergei-5bb34238bb21a7ab3b0d2b84b88d7651.mp3";